import './index.less';

import { Button } from '@bfe/moly';
import { FundPasswordKeyIcon } from '@bfe/moly-icons';
import { message, Space, Tooltip } from 'antd';
import React, { useLayoutEffect, useState } from 'react';

import AccountBasicItem from '@/components/AccountBasicItem';
import BySecurity from '@/components/NewSecurity';
import { SecuritySettingModalNames } from '@/components/SecuritySettingModalManager';
import { useUserSecurityProfile } from '@/hooks/useUserSecurityProfile';
import { useI18nContext } from '@/i18n/I18n';
import * as FundPasswordApi from '@/services/fundPassword';
import { useSecuritySettingModal } from '@/store/useSecuritySettingModal/useSecuritySettingModal';
import { useStore } from '@/store/useStore';
import { isUnAuthPage } from '@/utils/loginAuth';
import redirectUrlMap from '@/utils/redirectUrlMap';

const FundPassword = () => {
  const { msgError } = useStore();
  const [$t] = useI18nContext();
  const { userSecurityInfo, updateUserSecurityProfile } =
    useUserSecurityProfile((error: any) => {
      if (error?.ret_code === 10007) {
        if (!isUnAuthPage()) {
          if (window.location.pathname.indexOf('/notifications') > -1) {
            const redirectUrl = `?redirect_url=${encodeURIComponent(
              window.location.href,
            )}`;
            redirectUrlMap.redirectLogin(redirectUrl);
          } else {
            redirectUrlMap.redirectLogin();
          }
        }
      }
    });
  const { openSecuritySettingModal } = useSecuritySettingModal();

  const [showRiskToken, setShowRiskToken] = useState<string>('');
  const successFn = (str: string) => {
    unbindOperation(str, false);
  };
  const handleClick = () => {
    openSecuritySettingModal(SecuritySettingModalNames.PaymentPassword);
  };

  const errorMsg: { [key: string]: string } = {
    40052: $t('passwordsNotmatch'),
    40053: $t('fundPwdNotExist'),
    40054: $t('fundPwdIsExist'), // 资金密码不存在
    40056: $t('newFundPwdNotSameAsPwd'), // 资金密码与登录密码一致
  };
  const unbindOperation = (risk_token: string, open_security: boolean) => {
    FundPasswordApi.unbindFundPassword(risk_token)
      .then((res: any) => {
        if (open_security) {
          if (res?.result?.risk_token_type === 'pass') {
            message.success($t('unlinkFundPwdSuccess'));
            redirectUrlMap.redirectLogin();
          } else if (res?.result?.risk_token_type === 'reject') {
            message.error($t('securityReturnReject'));
          } else {
            if (res?.result?.risk_token) {
              setShowRiskToken(res?.result?.risk_token);
            }
          }
        } else {
          message.success($t('unlinkFundPwdSuccess'));
          setShowRiskToken('');
          updateUserSecurityProfile();
        }
      })
      .catch((error: any) => {
        const { ret_code } = error;
        errorMsg[ret_code]
          ? message.error(errorMsg[ret_code])
          : msgError(error);
      });
  };
  const unbindFundPwd = () => {
    unbindOperation('', true);
  };

  useLayoutEffect(() => {
    if (
      userSecurityInfo?.latestLoginRecord?.created_at &&
      !userSecurityInfo?.hasPaymentPassword
    ) {
      const type = window.location.search.replace('?_type=', '');
      if (type === 'assetType') {
        handleClick();
      }
    }
  }, [userSecurityInfo]);

  return (
    <>
      <AccountBasicItem
        icon="fundpassword"
        molyIcon={<FundPasswordKeyIcon />}
        text={$t('fundPassword')}
        subText={$t('fundPasswordUseful')}
        status={userSecurityInfo?.hasPaymentPassword}
        statusNode={
          <>
            {userSecurityInfo?.hasPaymentPassword ? (
              <span>{$t('Set up')}</span>
            ) : (
              <span className="not-set-text">{$t('Not Set')}</span>
            )}
          </>
        }
        operation={
          <>
            {userSecurityInfo?.hasPaymentPassword ? (
              <Space>
                <Tooltip title={$t('disabledWithdrawal24hours')}>
                  <Button
                    size="small"
                    data-radius="small"
                    variant="secondary"
                    onClick={unbindFundPwd}
                  >
                    {$t('Disable')}
                  </Button>
                </Tooltip>
                <Tooltip title={$t('changeFundPasswordTip')}>
                  <Button
                    size="small"
                    data-radius="small"
                    variant="primary"
                    onClick={handleClick}
                  >
                    {$t('modify')}
                  </Button>
                </Tooltip>
              </Space>
            ) : (
              <Button
                size="small"
                data-radius="small"
                variant="primary"
                onClick={handleClick}
              >
                {$t('Set up')}
              </Button>
            )}
          </>
        }
      />

      {showRiskToken && (
        <BySecurity
          risk_token={showRiskToken}
          faceFailHandler={() => {
            setShowRiskToken('');
          }}
          clearTokenHandler={() => {
            setShowRiskToken('');
          }}
          callBack={(res: any) => {
            successFn(res?.result.risk_token);
          }}
        />
      )}
    </>
  );
};
export default FundPassword;
